import { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { RoleEnum } from 'src/api';
import { isInvalidNumeric, useOfferMassiveUpdateContext } from './OfferMassiveUpdateContext';
import type { OffertaDTO } from 'src/api';

type EditableCellProps = {
  value: any;
  row: any;
  column: any;
  formatter?: (value: any) => string | null | undefined;
};

const EditableCell = ({ value: initialValue, row, column, formatter }: EditableCellProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const { pendingChanges, setChange } = useOfferMassiveUpdateContext();
  const { userRole } = useAuth();

  const offertaId: string = row.original?.offerta?.id;
  const fieldId = column.id as keyof OffertaDTO;

  const pendingEntry = pendingChanges[offertaId];
  const isDirty = pendingEntry?.changes != null && fieldId in pendingEntry.changes;
  const currentValue = isDirty ? (pendingEntry.changes as any)[fieldId] : initialValue;
  const isInvalid = isDirty && isInvalidNumeric(fieldId, currentValue);

  const displayValue = formatter && !isInvalid ? formatter(currentValue) : (currentValue ?? '-');

  const dirtyBg = isInvalid ? '#f8d7da' : '#d4edda';

  if (userRole !== RoleEnum.MASTER) {
    return <span>{displayValue}</span>;
  }

  if (isEditing) {
    return (
      <input
        autoFocus
        type="text"
        value={currentValue ?? ''}
        className="form-control form-control-sm"
        style={{ minWidth: 80, background: isDirty ? dirtyBg : undefined }}
        onChange={(e) => setChange(offertaId, fieldId, e.target.value, row.original)}
        onBlur={() => setIsEditing(false)}
        onKeyDown={(e) => { if (e.key === 'Enter') setIsEditing(false); }}
      />
    );
  }

  return (
    <span
      role="button"
      onClick={() => setIsEditing(true)}
      style={{
        background: isDirty ? dirtyBg : 'transparent',
        cursor: 'pointer',
        display: 'inline-block',
        minWidth: 80,
        padding: '2px 4px',
        borderRadius: 3,
      }}
    >
      {displayValue}
    </span>
  );
};

export default EditableCell;
